import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedRelative } from 'react-intl';
import styled from 'styled-components';

import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';
import ActivityStore from '../../store/activityStore';
import FeatureFlagsStore from '../../store/featureFlagsStore';
import GroupedList from '../GroupedList';

import YourWorkRow from './YourWorkRow';

const RecentlyViewedContent = styled.div`
  flex-grow: 1;
  width: 100%;
`;

interface Props {
  activityStore: ActivityStore;
  featureFlagsStore: FeatureFlagsStore;
}

@observer
class Viewed extends React.Component<Props & AnalyticsConsumerProps> {
  componentDidMount() {
    this.props.analytics.track('tabViewed', 'viewed', {
      itemCount: this.props.activityStore.views.length,
    });
  }

  render() {
    const { views } = this.props.activityStore;
    return (
      <RecentlyViewedContent>
        <GroupedList
          data={views}
          renderItem={view => {
            return (
              <YourWorkRow
                analyticsAttributes={{
                  eventType: view.eventType,
                  tab: 'viewed',
                }}
                key={view.object.id}
                object={view.object}
                contributors={view.contributors}
                container={view.container}
                fullIndex={view.fullIndex}
              >
                <FormattedRelative value={view.timestamp} />
              </YourWorkRow>
            );
          }}
        />
      </RecentlyViewedContent>
    );
  }
}

export default inject(({ activityStore, featureFlagsStore }) => ({ activityStore, featureFlagsStore }))(
  withAnalytics(Viewed),
);
